import { RefObject, useCallback, useMemo, useState } from 'react';

import useOnOutsideElementClick from '@/hooks/common/useOnOutsideElementClick';

import { SelectOptions } from './types';

interface IUseSelect<T> {
  isOpen: boolean;
  searchText: string;
  openOptions: () => void;
  closeOptions: () => void;
  search: (text: string) => void;
  filteredOptions: SelectOptions<T>;
}

const useSelect = <T>(
  selectRef: RefObject<HTMLElement | null>,
  selectButtonRef: RefObject<HTMLButtonElement | null>,
  options: SelectOptions<T>
): IUseSelect<T> => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState('');

  const closeOptions = useCallback(() => {
    setIsOpen(false);
    setSearchText('');
    selectButtonRef?.current?.focus();
  }, [selectButtonRef]);

  useOnOutsideElementClick(selectRef, closeOptions);

  const filteredOptions = useMemo(() => {
    return options.filter((item) => {
      return item.label.toLowerCase().includes(searchText.toLowerCase());
    });
  }, [options, searchText]);

  function openOptions() {
    setIsOpen(true);
  }

  function search(text: string) {
    setSearchText(text);
  }

  return {
    isOpen,
    openOptions,
    closeOptions,
    search,
    searchText,
    filteredOptions,
  };
};

export default useSelect;
